import { Inject, Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { USER_REPOSITORY_TOKEN } from "@karma-games/angular-devkit/src/lib/modules/user";
import { IClientUserRepository } from "../interfaces";
import { Observable } from "rxjs";

@Injectable()
export class SubscribeBalanceUpdateUseCase implements IUseCase<void, Observable<number>> {
    constructor(@Inject(USER_REPOSITORY_TOKEN) private userRepository: IClientUserRepository) {
    }

    execute(): Observable<number> {
        return this.userRepository.subscribeBalanceUpdate();
    }
}
